import apiFetch from '../apiFetch'
export default function (token, filters) {
  return apiFetch({ endPoint: 'Fleets/CreateOrUpdate', method: 'POST', body: filters, token: token })
}
